import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNutshelltoOfficeRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 128 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.125 5.886a1.01 1.01 0 0 1-.951-1.208l.684-3.636a1 1 0 0 0 .019-.17c0-.771-1.08-.872-2.48-.872s-2.484.1-2.484.872q0 .086.02.17l.693 3.636a1.016 1.016 0 0 1-.977 1.198C4.949 6.11.223 8.304.223 12.306v1.539a.736.736 0 0 0 .735.736H13.15a.706.706 0 0 1 .739.735.684.684 0 0 1-.586.687l-9.04 1.752a.69.69 0 0 0-.586.713v3.096c0 5.944 4.648 10.947 10.72 10.947A10.743 10.743 0 0 0 25.139 21.77v-6.492a.714.714 0 0 1 .736-.71h1.953a.736.736 0 0 0 .749-.735v-1.54c0-4.01-4.727-6.048-11.452-6.406",
			fill: "#fe5800"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.777 14.656a1.6 1.6 0 0 0 0 3.2zm29.932 2.731a1.6 1.6 0 0 0 0-2.263L67.526 4.942a1.6 1.6 0 0 0-2.262 2.263l9.05 9.05-9.05 9.052a1.6 1.6 0 0 0 2.262 2.262zm-29.932-1.131v1.6h28.8v-3.2h-28.8z",
			fill: "#4d4540"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m115.027 27.756-16-2.5 16 6 9.5-2.5v-25l-9.5-2.5-16 6v17.5l5.5-2v-14.5l10.5-2.5z",
			fill: "#eb3c00"
		})
	]
});
export default SvgNutshelltoOfficeRegularIcon;
